<template>
  <section class="empty mr-0 lg:mr-4 flex flex-col">
    <h2 v-text="`There are no ${status} Communications`" />
    <p>Communications provide a way to communicate with members.</p>
    <NepPopper
      v-cloak
      v-can="['create-blog-entries', 'create-email', 'create-sms']"
      popper-class="z-100 popper popper-simple popper-arrow"
      button="Create New Communication"
    >
      <div class="flex flex-col">
        <a
          v-can="'create-blog-entries'"
          :href="$urlGenerator.active('communications/blog/create')"
          class="mb-2"
          v-text="'Create New Blog Post'"
        />
        <a
          v-can="'create-email'"
          :href="$urlGenerator.active('communications/email/create')"
          class="mb-2"
          v-text="'Create New Email'"
        />
        <a
          v-can="'create-sms'"
          :href="$urlGenerator.active('communications/sms/create')"
          v-text="'Create New Text Message'"
        />
      </div>
    </NepPopper>
  </section>
</template>

<script type="text/babel">
import NepPopper from 'Design/Resources/assets/design-system/js/components/NepPopper'

export default {
  name: 'CommunicationsNoResults',
  components: {
    NepPopper,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
}
</script>
